import React, { useRef } from "react";
import logoAmc from '../../../../../assets/imgs/dashboard-admin/export/capture/amc-mexico.png'
import logoConnect from '../../../../../assets/imgs/dashboard-admin/export/capture/connect-amc-copia.png'
import './capture.css'

function CaptureDetails({ masterNumber, masterData }) {

    const handlePrint = () => {
        const fechaOriginal = new Date(); // O la fecha que estás manejando

        // Obtener componentes
        const dia = String(fechaOriginal.getDate()).padStart(2, '0');
        const mes = String(fechaOriginal.getMonth() + 1).padStart(2, '0'); // Se suma 1 porque los meses van de 0 a 11
        const anio = fechaOriginal.getFullYear();

        const fechaFinal = `${dia}/${mes}/${anio}`;
        const createTableRow = (doc, thContent, tdContent) => {
            const tr = doc.createElement('tr');
            
            const th = doc.createElement('th');
            thContent.forEach(text => {
                const p = doc.createElement('p');
                p.textContent = text;
                th.appendChild(p);
            });
            
            const td = doc.createElement('td');
            tdContent.forEach(text => {
                const p = doc.createElement('p');
                p.textContent = text;
                td.appendChild(p);
            });
            
            tr.appendChild(th);
            tr.appendChild(td);
            return tr;
        };

        const cssStyles = `
            body {
                font-family: Arial, sans-serif;
                margin: 0px;
                padding: 20px;
            }
            .image-container {
                display: flex;
                justify-content: center;
                gap: 20px;
                margin-bottom: 20px;
            }
            .logo-image-amc {
                width: 25%;
                height: 25%;
            }
            .logo-image-connect {
                width: 32%;
                height: 32%;
            }
            .header {
                text-align: center;
                font-weight: normal;
                margin-bottom: 20px;
            }
            .logo {
                text-align: right;
            }
            .table {
                width: 100%;
                border-collapse: collapse;
            }
            .table th, .table td {
                border: 1px solid black;
                padding: 10px;
                text-align: left;
            }
            .table th {
                width: 60%;
                font-weight: normal;
            }
            .table td {
                width: 40%;
            }
            .table p {
                margin: 2px 0;
                font-size: 12px;
            }
            .footer {
                margin-top: 30px;
                font-size: 12px;
                display: flex;
                justify-content: space-between;
            }
        `;

        const printScript = `
            window.onload = function () {
                window.print();
                window.close();
            };
        `;

        const safeAwb = masterData?.data?.resp?.awb ?? '';

        const printWindow = window.open("", "", "width=800,height=600");
        const doc = printWindow.document;

        // 2. Construir el <head>
        doc.title = "Horus";
        const styleElement = doc.createElement('style');
        styleElement.textContent = cssStyles;
        doc.head.appendChild(styleElement);

        const body = doc.body;

        const imageContainer = doc.createElement('div');
        imageContainer.className = 'image-container';

        const imgConnect = doc.createElement('img');
        imgConnect.src = logoConnect;
        imgConnect.className = 'logo-image-connect';
        imageContainer.appendChild(imgConnect);
        

        const imgAmc = doc.createElement('img');
        imgAmc.src = logoAmc;
        imgAmc.className = 'logo-image-amc';
        imageContainer.appendChild(imgAmc);

        
        body.appendChild(imageContainer);

        const header = doc.createElement('div');
        header.className = 'header';
        
        const pHeader1 = doc.createElement('p');
        pHeader1.textContent = 'VERIFICACIÓN DE IDENTIFICACIÓN PARA EMBARQUES CON DESTINO FINAL Ó TRANSITO HACIA CUALQUIER DESTINO INTERNACIONAL';
        header.appendChild(pHeader1);

        const pHeader2 = doc.createElement('p');
        pHeader2.textContent = 'ID VERIFICATION FOR CARGO WITH FINAL DESTINATION OR TRANSIT AT ANY INTENATIONAL DESTINATION';
        header.appendChild(pHeader2);
        
        body.appendChild(header);

        // Tabla
        const table = doc.createElement('table');
        table.className = 'table';
        const tbody = doc.createElement('tbody');

        const valoresBase = [fechaFinal, safeAwb];

        const casasParaIterar = masterData.data.allHouses || [];

        const valoresIterados = casasParaIterar.map((item, index) => (
            item.hbs // Esto asume que item.hbs es el valor de la celda que deseas
        ));
        
        const listaFinal = [
            ...valoresBase, // [fechaFinal, safeAwb]
            ...valoresIterados, // [hbs1, hbs2, hbs3, ...]
        ];

        tbody.appendChild(createTableRow(doc, 
            ['Fecha y Número de Guía Aérea:', 'AWB Date and Number: ', masterData.data.noHouses > 0 ? 'HBS' : ''], 
            listaFinal
        ));

        tbody.appendChild(createTableRow(doc,
            ['Tipo de primera identificación revisada', 'Type of first ID reviewed'],
            ['Gafete Aduanal', masterData?.data?.badge?.number || '-']
        ));

        tbody.appendChild(createTableRow(doc,
            ['¿Coincide la foto de la identificación? (Si/No)', 'Matching photo on ID? (Yes/No)'],
            ['SÍ']
        ));

        tbody.appendChild(createTableRow(doc,
            ['Este campo solo aplica dentro de los Estados Unidos (Anotar NA si no aplica)', 'SIDA badge or evidence of STA (after august 1, 2010)? (Yes/No) (Only within USA)'],
            ['N/A']
        ));

        tbody.appendChild(createTableRow(doc,
            ['Tipo de segunda identificación revisada (si la primera es una Identificación sin fotografía emitida por una autoridad gubernamental):', 'Type of second ID reviewed (if the first was not a photo ID issue by a government authority)'],
            ['N/A']
        ));

        tbody.appendChild(createTableRow(doc,
            ['¿Coincide la foto de la identificación?(Si/No)', 'Matching photo on ID? (Yes/No)'],
            ['SÍ']
        ));

        tbody.appendChild(createTableRow(doc,
            ['Nombre de la persona que entrega el embarque:', 'Printed name of individual from whom the cargo shipment was accepted:'],
            [masterData?.data?.badge?.name || '-']
        ));

        tbody.appendChild(createTableRow(doc,
            ['Nombre de la persona que transporta el embarque:', 'Printed name of individual whom transport the shipment'],
            [masterData?.data?.badge?.name || '-']
        ));

        tbody.appendChild(createTableRow(doc,
            ['Nombre de la Empresa (si aplica, si no aplica anotar NA)', 'Company name (where applicable):'],
            ['-']
        ));

        tbody.appendChild(createTableRow(doc,
            ['Nombre del empleado que verificó la información de identificación', 'Name of employee or its authorized representative who verified ID information:'],
            [1]
        ));

        table.appendChild(tbody);
        body.appendChild(table);

        // Pie de página (Footer)
        const footer = doc.createElement('div');
        footer.className = 'footer';

        const spanLeft = doc.createElement('span');
        spanLeft.className = 'left';
        spanLeft.textContent = 'FJEX-01.35 R 01/23';
        footer.appendChild(spanLeft);

        const spanRight = doc.createElement('span');
        spanRight.className = 'right';
        spanRight.textContent = 'Revisión 01/23, Marzo 2023';
        footer.appendChild(spanRight);
        
        body.appendChild(footer);

        const scriptElement = doc.createElement('script');
        scriptElement.textContent = printScript;
        body.appendChild(scriptElement);
    };

    return(
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-3">
                        <label for="loadType" class="amc-label">Master</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.resp.awb}</p>
                    </div>
                    <div className="col-3">
                        <label for="origin" class="amc-label">Origen</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.resp.orig}</p>
                    </div>
                    <div className="col-3">
                        <label for="destiny" class="amc-label">Destino</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.resp.dest}</p>
                    </div>
                    <div className="col-3">
                        <label for="destiny" class="amc-label">Piezas registradas</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.resp.pieces}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <label class="amc-label">Gross weight registrado</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.resp.weigth}</p>
                    </div>
                    <div className="col-3">
                        <label for="origin" class="amc-label">Houses registradas</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.noHouses}</p>
                    </div>
                    <div className="col-3">
                        <label for="destiny" class="amc-label">Descripción</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.resp.description}</p>
                    </div>
                    <div className="col-3">
                        <label for="destiny" class="amc-label">Remitente</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.shipper?.name || '-'}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <label for="origin" class="amc-label">Consignatario</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.consignee?.name || '-'}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label class="amc-label">*Origen inicial</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.resp?.final_orig || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="origin" class="amc-label">*Destino final</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.resp?.final_dest || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="destiny" class="amc-label">*Tipo de mercancía</label>
                        <p style={{marginTop: '-10px'}}>{
                            masterData?.data?.merch_type
                                ?.find(item => item.id === parseInt(masterData?.data?.expMaster?.merchandise_type))
                                ?.name 
                                || '-'       
                        }</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label class="amc-label">*Chargeable Weight total Master</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.resp?.chargeable_weight || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="origin" class="amc-label">*Volúmen total Master</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.resp?.volume || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="destiny" class="amc-label">Agente aduanal</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.agent || '-'}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label class="amc-label">*Moneda</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.currencies_catalog[masterData.data.exp_assig.id_currency]?.name || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="origin" class="amc-label">Valor Declarado</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.exp_assig?.value || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="destiny" class="amc-label">Pedimento</label> 
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.exp_assig?.pediment || '-'}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label class="amc-label">Clave</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.exp_assig?.clave || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="origin" class="amc-label">*ID</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.badge?.number || '-'}</p>
                    </div>
                    <div className="col-4">
                        <label for="destiny" class="amc-label">*Nombre</label>
                        <p style={{marginTop: '-10px'}}>{masterData?.data?.badge?.name || '-'}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <label class="amc-label">*Tipo de carga</label>
                        <p style={{marginTop: '-10px'}}>{masterData.data.is_consolidated === 1 ? 'Consolidada' : 'Parcial'}</p>
                    </div>
                </div>

                {masterData.data.noHouses > 0&& (
                    <div className="row">
                        <div className="col-12 table-responsive">
                            <table
                              className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                              role="grid"
                              aria-describedby="datatables_info"
                            >
                                <thead className="thead-detail">
                                    <tr >
                                        <th className="thead-detail">*HBS</th>
                                        <th className="thead-detail">*Piezas</th>
                                        <th className="thead-detail">*Gross Weight</th>
                                        <th className="thead-detail">*Chargeable Weight</th>
                                        <th className="thead-detail">*Volúmen</th>
                                        <th className="thead-detail">*Tipo de mercancía</th>
                                        <th className="thead-detail">*Descripción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {masterData.data.allHouses.map((item, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{item.hbs}</td>
                                            <td className="text-center">{item.pieces}</td>
                                            <td className="text-center">{Number(item.gross_weight).toFixed(2)}</td>
                                            <td className="text-center">{Number(item.chargeable_weight).toFixed(2)}</td>
                                            <td className="text-center">{Number(item.volume).toFixed(2)}</td>
                                            <td className="text-center">{masterData.data.merch_type_con[item.merchandise_type_id]}</td>
                                            <td className="text-center">{item.description}</td>
                                        </tr>
                                     ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col mt-4 d-flex justify-content-end gap-3">
                        <button className='btnn' onClick={handlePrint} >Imprimir Formato</button>
                    </div>
                </div>
            </div>


        </>
    );
}

export default CaptureDetails;